angular.module('gym').factory('ProspectForms', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var gymId;
  gymId = $rootScope.toParams.gymId;
  return Restangular.one('gyms', gymId).all('forms').all('prospect_forms.json');
}]);
